(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fpoo-eb-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.fpoo-eb-buybox').forEach(function (root) {
      var ctas = root.querySelectorAll('.eb-cta, .eb-sticky__cta');
      var group = root.querySelector('.eb-variants');
      var keys = ['plan', 'variant-id', 'selling-plan', 'bundle-id', 'box-size-id', 'component-variant-ids', 'discount-code'];
      var stickyVariant = root.querySelector('[data-eb-sticky-variant]');
      var stickyPrice = root.querySelector('[data-eb-sticky-price]');

      if (ctas.length && group) {
        function syncCta() {
          var checked = group.querySelector('input[type="radio"]:checked');
          if (!checked) return;
          ctas.forEach(function (cta) {
            keys.forEach(function (k) {
              var v = checked.getAttribute('data-' + k);
              if (v) {
                cta.setAttribute('data-' + k, v);
              } else {
                cta.removeAttribute('data-' + k);
              }
            });
          });
          if (stickyVariant && checked.getAttribute('data-name')) {
            stickyVariant.textContent = checked.getAttribute('data-name');
          }
          if (stickyPrice && checked.getAttribute('data-price')) {
            var priceWas = checked.getAttribute('data-price-was');
            var priceNow = checked.getAttribute('data-price');
            stickyPrice.innerHTML = (priceWas ? '<s>' + priceWas + '</s> ' : '') + priceNow;
          }
        }
        group.addEventListener('change', syncCta);
        syncCta();
      }

      /* Sticky bar reveal: show once the buy box scrolls out of view,
         hide again near the very bottom so it never covers the footer. */
      var bar = root.querySelector('[data-eb-sticky]');
      if (bar) {
        var syncSticky = function () {
          var pastBuyBox = root.getBoundingClientRect().bottom < 0;
          var doc = document.documentElement;
          var remaining = doc.scrollHeight - (window.scrollY + window.innerHeight);
          var atPageEnd = remaining <= 120;
          bar.classList.toggle('is-on', pastBuyBox && !atPageEnd);
        };
        window.addEventListener('scroll', syncSticky, { passive: true });
        window.addEventListener('resize', syncSticky);
        syncSticky();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fpoo-eb-final"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fpoo-eb-final [data-eb-scroll-top]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fpoo-eb-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.fpoo-eb-gallery').forEach(function (root) {
      /* Gallery thumbnail swap */
      var gallery = root.querySelector('[data-eb-gallery]');
      if (gallery) {
        var mainImg = gallery.querySelector('.eb-gallery-img');
        var flag = gallery.querySelector('[data-eb-flag]');
        root.querySelectorAll('[data-eb-thumb]').forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            if (mainImg && thumb.dataset.src) {
              mainImg.src = thumb.dataset.src;
              mainImg.removeAttribute('srcset');
              if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
            }
            if (flag) {
              if (thumb.dataset.badge) {
                flag.textContent = thumb.dataset.badge;
                flag.hidden = false;
              } else {
                flag.hidden = true;
              }
            }
            root.querySelectorAll('[data-eb-thumb]').forEach(function (t) {
              t.classList.remove('is-active');
            });
            thumb.classList.add('is-active');
          });
        });
      }
    });
  })();

  (function () {
    var buybox = document.querySelector('.fpoo-eb-hero-buybox');
    var social = document.querySelector('.fpoo-eb-hero-social');
    var header = document.querySelector('.fpoo-eb-header-section');
    if (!buybox || !social) return;

    var main = buybox.parentElement;
    var mq = window.matchMedia('(min-width: 1001px)');
    var GAP = 0;
    var metrics = null;
    var ticking = false;

    function reset() {
      buybox.style.position = '';
      buybox.style.top = '';
      buybox.style.left = '';
      buybox.style.width = '';
      buybox.style.marginLeft = '';
      buybox.style.marginRight = '';
    }

    function measure() {
      reset();
      if (main && getComputedStyle(main).position === 'static') {
        main.style.position = 'relative';
      }
      var headerH = header ? header.offsetHeight : 0;
      var topOffset = headerH + GAP;
      var rect = buybox.getBoundingClientRect();
      var boxTopDoc = rect.top + window.pageYOffset;
      var mainRect = main.getBoundingClientRect();
      var mainTopDoc = mainRect.top + window.pageYOffset;
      var heroBottomDoc = social.getBoundingClientRect().bottom + window.pageYOffset;
      metrics = {
        topOffset: topOffset,
        boxLeftViewport: rect.left,
        boxLeftInMain: rect.left - mainRect.left,
        boxWidth: rect.width,
        pinStart: Math.max(0, boxTopDoc - topOffset),
        pinEnd: heroBottomDoc - rect.height - topOffset,
        parkTop: heroBottomDoc - rect.height - mainTopDoc
      };
    }

    function apply() {
      ticking = false;
      if (!mq.matches) { reset(); return; }
      if (!metrics) measure();
      if (metrics.pinEnd <= metrics.pinStart) { reset(); return; }
      var y = window.pageYOffset;
      if (y <= metrics.pinStart) {
        reset();
      } else if (y < metrics.pinEnd) {
        buybox.style.position = 'fixed';
        buybox.style.top = metrics.topOffset + 'px';
        buybox.style.left = metrics.boxLeftViewport + 'px';
        buybox.style.width = metrics.boxWidth + 'px';
        buybox.style.marginLeft = '0';
        buybox.style.marginRight = '0';
      } else {
        buybox.style.position = 'absolute';
        buybox.style.top = metrics.parkTop + 'px';
        buybox.style.left = metrics.boxLeftInMain + 'px';
        buybox.style.width = metrics.boxWidth + 'px';
        buybox.style.marginLeft = '0';
        buybox.style.marginRight = '0';
      }
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }
    function remeasure() {
      metrics = null;
      if (mq.matches) measure();
      apply();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);
    if (mq.addEventListener) mq.addEventListener('change', remeasure);
    remeasure();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fpoo-eb-social"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.fpoo-eb-social [data-eb-play]').forEach(function (facade) {
      facade.addEventListener('click', function () {
        var frame = facade.closest('[data-eb-video]');
        var embed = facade.dataset.embed;
        if (embed) {
          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', embed);
          iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', 'Video');
          frame.appendChild(iframe);
          facade.remove();
        } else {
          var video = frame.querySelector('.eb-video__file');
          if (video) {
            facade.remove();
            video.play();
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
